import { render, staticRenderFns } from "./ReturnModal.vue?vue&type=template&id=2f1d1ee6"
import script from "./ReturnModal.vue?vue&type=script&lang=js"
export * from "./ReturnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports